/**
 * TEST ROUTES
 */

export default [
  // {
  //   path: '/:lang?/demo',
  //   name: 'demo',
  //   component: () => import('@/views/Demo.vue'),
  //   meta: { layout: 'default' },
  // },
  {
    path: '/:lang?/demo/lerna-import',
    name: 'demo-core-lerna-import',
    component: () => import('@/views/demo/LernaImport.vue'),
    meta: { layout: 'default' },
  },
  {
    path: '/:lang?/demo/core-js',
    name: 'demo-core-js',
    component: () => import('@/views/demo/CoreJs.vue'),
    meta: { layout: 'default' },
  },
  {
    path: '/:lang?/demo/input-mask',
    name: 'demo-input-mask',
    component: () => import('@/views/demo/InputVMask.vue'),
    meta: { layout: 'default' },
  },
  {
    path: '/:lang?/demo/vuelidate',
    name: 'demo-vuelidate',
    component: () => import('@/views/demo/Vuelidate.vue'),
    meta: { layout: 'default' },
  },
  {
    path: '/:lang?/demo/modal',
    name: 'demo-modal',
    component: () => import('@/views/demo/ModalDemo.vue'),
    meta: { layout: 'default' },
  },
  {
    path: '/:lang?/demo/font',
    name: 'demo-font',
    component: () => import('@/views/demo/Font.vue'),
    meta: { layout: 'default' },
  },
  {
    path: '/:lang?/demo/swiper',
    name: 'demo-swiper',
    component: () => import('@/views/demo/Swiper.vue'),
    meta: { layout: 'default' },
  },
  {
    path: '/:lang?/demo/onfido',
    name: 'demo-onfido',
    component: () => import('@/views/demo/OnfidoTest.vue'),
    meta: { layout: 'default' },
  },
  // {
  //   path: '/:lang?/demo/checkout',
  //   name: 'checkout',
  //   component: () => import('@/views/demo/Checkout.vue'),
  //   meta: { layout: 'default' },
  // },
  {
    path: '/:lang?/demo/test',
    name: 'demo-test',
    component: () => import('@/views/demo/Test.vue'),
    meta: { layout: 'default' },
  },
  {
    name: 'demo-uploader-service',
    path: '/:lang?/demo/uploader-service',
    component: () => import('@/views/demo/UploaderService.vue'),
  },
];

